import { faList } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { DisplayL } from '@sorare/core/src/atoms/typography';

const Title = styled(Vertical)`
  align-items: flex-start;
  gap: var(--double-unit);
`;

export const PublicWatchlistsTitle = ({ count }: { count: number }) => {
  return (
    <Title>
      <FontAwesomeIcon icon={faList} size="3x" />
      <DisplayL>
        <FormattedMessage
          id="PublicWatchlists.title"
          defaultMessage="{count, plural, one {# Public Watchlist} other {# Public Watchlists}}"
          values={{ count }}
        />
      </DisplayL>
    </Title>
  );
};
